import {css, styled} from 'styled-components';

import {MEDIA_QUERY_TABLET_AND_DESKTOP} from '@shared_web/breakpoints';

const WrapperCss = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  padding: 20px;
`;

export const FormWrapper = styled.form`
  ${WrapperCss}
  ${MEDIA_QUERY_TABLET_AND_DESKTOP} {
    align-items: center;
    justify-content: flex-start;
    gap: 32px;
    margin-top: 32px;
  }
`;

export const PageWrapper = styled.div`
  ${WrapperCss}
`;

export const TabWrapper = styled.div<{$noPadding?: boolean}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 10px;
  ${p => !p.$noPadding && 'padding: 10px;'}
  height: 100%;
`;

export const TableWrapper = styled.div`
  height: 100%;
  flex-grow: 1;
  overflow: auto;
  margin-left: -10px;
  width: calc(100% + 20px);
`;

export const StatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 10px;
  height: 100%;
`;

export const ChartWrapper = styled.div`
  width: 100%;
  max-width: 500px; // ou la largeur souhaitée
  margin: 0 auto;
`;

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
